export default __webpack_public_path__ + "static/media/Hair_18_F_C4.fe6cb112.svg";